'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setUserFollow = setUserFollow;
exports.getIsFollowing = getIsFollowing;
exports.followUser = followUser;
exports.setReactionShouldAnimateIn = setReactionShouldAnimateIn;
exports.unfollowUser = unfollowUser;
exports.toggleFollowUserIfNeeded = toggleFollowUserIfNeeded;
exports.setReactionShouldAnimateOut = setReactionShouldAnimateOut;
exports.addReactionIfNeeded = addReactionIfNeeded;
exports.removeReactionIfNeeded = removeReactionIfNeeded;
exports.toggleReactionIfNeeded = toggleReactionIfNeeded;
exports.addContentReactionIfNeeded = addContentReactionIfNeeded;
exports.fetchReactionUsersIfNeeded = fetchReactionUsersIfNeeded;
exports.fetchTagUsersIfNeeded = fetchTagUsersIfNeeded;
exports.fetchCommunityContentMetadataIfNeeded = fetchCommunityContentMetadataIfNeeded;
exports.fetchCurrentUserDetailsIfNeeded = fetchCurrentUserDetailsIfNeeded;
exports.addFeedItems = addFeedItems;
exports.fetchFeedItemIfNeeded = fetchFeedItemIfNeeded;
exports.dismissFeedItem = dismissFeedItem;
exports.hideConfirmDismissFeedItem = hideConfirmDismissFeedItem;
exports.showConfirmDismissFeedItem = showConfirmDismissFeedItem;
exports.receiveUserTimeline = receiveUserTimeline;
exports.fetchMoreInTimeline = fetchMoreInTimeline;
exports.fetchUserTimelineIfNeeded = fetchUserTimelineIfNeeded;
exports.fetchMiniProfileIfNeeded = fetchMiniProfileIfNeeded;
exports.showMiniProfile = showMiniProfile;
exports.hideMiniProfile = hideMiniProfile;
exports.shareContent = shareContent;
exports.communityContentShared = communityContentShared;
exports.closeTheatre = closeTheatre;
exports.requestRecommendedVideos = requestRecommendedVideos;
exports.failedToGetRecommendedVideos = failedToGetRecommendedVideos;
exports.receiveRecommendedVideos = receiveRecommendedVideos;
exports.getRecommendedVideos = getRecommendedVideos;
exports.selectTheatreRecommendation = selectTheatreRecommendation;
exports.shareTheatreRecommendation = shareTheatreRecommendation;
exports.pauseAllVideos = pauseAllVideos;
exports.openTheatre = openTheatre;
exports.communityContentEnterView = communityContentEnterView;
exports.communityContentLeaveView = communityContentLeaveView;
exports.communityContentVideoPlay = communityContentVideoPlay;
exports.communityContentVideoPositionUpdated = communityContentVideoPositionUpdated;
exports.communityContentVideoStopped = communityContentVideoStopped;
exports.fetchHeaderBid = fetchHeaderBid;

var _services = require('../../utils/services');

var _services2 = _interopRequireDefault(_services);

var _pixelTracker = require('../../shared/pixel-tracker');

var _pixelTracker2 = _interopRequireDefault(_pixelTracker);

var _presetFilterType = require('../../shared/preset-filter-type');

var _presetFilterType2 = _interopRequireDefault(_presetFilterType);

var _actionTypes = require('./action-types');

var _featuredAthleteActionCreators = require('./featured-athlete-action-creators');

var _loggingUtil = require('../../utils/logging-util');

var _hudlVideoInterface = require('hudl-video-interface');

var _logValues = require('../../shared/logging/log-values');

var _sessionViews = require('../../utils/session-views');

var _sessionViews2 = _interopRequireDefault(_sessionViews);

var _communityContentUtil = require('../../utils/community-content-util');

var _communityContentUtil2 = _interopRequireDefault(_communityContentUtil);

var _comscore = require('../../utils/comscore');

var _comscore2 = _interopRequireDefault(_comscore);

var _adUtility = require('../../utils/ad-utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Helpers
function getReactionStatus(state, communityContentType, communityContentRelatedId, reaction) {
  var _state$reaction = state.reaction,
      contentReactions = _state$reaction.contentReactions,
      pendingContentReactions = _state$reaction.pendingContentReactions;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _contentReactions$com = contentReactions[communityContentIdKey].currentUserReactions,
      currentUserReactions = _contentReactions$com === undefined ? [] : _contentReactions$com;

  var pendingReactions = pendingContentReactions[communityContentIdKey] || [];

  var hasAlreadyReacted = currentUserReactions.includes(reaction);
  var hasPendingReaction = pendingReactions.includes(reaction);

  return { hasAlreadyReacted: hasAlreadyReacted, hasPendingReaction: hasPendingReaction };
}

function getCommunityIdString(communityContentId) {
  var type = communityContentId.type,
      relatedId = communityContentId.relatedId,
      secondaryRelatedId = communityContentId.secondaryRelatedId;

  return _communityContentUtil2.default.buildCommunityContentId(type, relatedId, secondaryRelatedId);
}

function getTracking(state, communityContentId) {
  return state.communityContent.tracking[communityContentId.type + '-' + communityContentId.relatedId] || {};
}

function getImpressionTrackingPixels(state, communityContentId) {
  return getTracking(state, communityContentId).onImpressionTrackingPixels || [];
}

function getVideoCompleteTrackingPixels(state, communityContentId) {
  return getTracking(state, communityContentId).onVideoCompleteTrackingPixels || [];
}

function getShareTrackingPixels(state, communityContentId) {
  return getTracking(state, communityContentId).onShareTrackingPixels || [];
}

function getQuartileTrackingPixels(state, quartile, communityContentId) {
  var tracking = getTracking(state, communityContentId);
  return [tracking.onPlayTrackingPixels, tracking.onVideoFirstQuartileTrackingPixels, tracking.onVideoMidpointQuartileTrackingPixels, tracking.onVideoThirdQuartileTrackingPixels][quartile] || [];
}

function getReactionTrackingPixels(state, type, relatedId) {
  return getTracking(state, { type: type, relatedId: relatedId }).onReactionTrackingPixels || [];
}

// Set user follow
function setUserFollow(feedUserType, feedUserRelatedId, isFollowing) {
  return {
    type: _actionTypes.SET_USER_FOLLOW,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId,
      isFollowing: isFollowing
    }
  };
}

function getFollowStatus(state, feedUserType, feedUserRelatedId) {
  var _state$follow = state.follow,
      _state$follow$userFol = _state$follow.userFollows,
      userFollows = _state$follow$userFol === undefined ? {} : _state$follow$userFol,
      _state$follow$pending = _state$follow.pendingUserFollows,
      pendingUserFollows = _state$follow$pending === undefined ? [] : _state$follow$pending;

  var feedUserIdKey = feedUserType + '-' + feedUserRelatedId;
  var isFollowing = userFollows[feedUserIdKey] || false;
  var isPending = pendingUserFollows.includes(feedUserIdKey);

  return { isFollowing: isFollowing, isPending: isPending };
}

// Is following
function requestIsFollowing(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.REQUEST_IS_FOLLOWING,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function failIsFollowing(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.FAIL_IS_FOLLOWING,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function getIsFollowing(feedUserType, feedUserRelatedId) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.follow.isFetching[feedUserType + '-' + feedUserRelatedId]) {
      return;
    }

    dispatch(requestIsFollowing(feedUserType, feedUserRelatedId));

    _services2.default.isFollowing(feedUserType, feedUserRelatedId).fail(function () {
      return dispatch(failIsFollowing(feedUserType, feedUserRelatedId));
    }).done(function (isFollowing) {
      return dispatch(setUserFollow(feedUserType, feedUserRelatedId, isFollowing));
    });
  };
}

// Follow user
function requestFollowUser(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.REQUEST_FOLLOW_USER,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function failFollowUser(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.FAIL_FOLLOW_USER,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function successFollowUser(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.SUCCESS_FOLLOW_USER,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function followUser(feedUserType, feedUserRelatedId) {
  var logData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (dispatch) {
    dispatch(requestFollowUser(feedUserType, feedUserRelatedId));

    var requestData = _extends({
      friendId: {
        type: feedUserType,
        relatedId: feedUserRelatedId
      }
    }, (0, _loggingUtil.generateObjectWithPascalCaseKeys)(logData));

    _services2.default.followUser(requestData).fail(function () {
      return dispatch(failFollowUser(feedUserType, feedUserRelatedId));
    }).done(function () {
      dispatch(successFollowUser(feedUserType, feedUserRelatedId));
      dispatch((0, _featuredAthleteActionCreators.shouldCheckForFollowingTeamUpdates)(true));
    });
  };
}

// Unfollow user
function requestUnfollowUser(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.REQUEST_UNFOLLOW_USER,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function getPreviousReactionCount(state, communityContentType, communityContentRelatedId, reaction) {
  var contentReactions = state.reaction.contentReactions;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _contentReactions$com2 = contentReactions[communityContentIdKey].reactions,
      reactions = _contentReactions$com2 === undefined ? {} : _contentReactions$com2;

  var _ref = reactions[reaction] || {},
      _ref$count = _ref.count,
      count = _ref$count === undefined ? 0 : _ref$count;

  return count;
}

// Manage reaction animations
function setReactionShouldAnimateIn(communityContentType, communityContentRelatedId, reaction, shouldAnimateIn) {
  return {
    type: _actionTypes.SET_REACTION_SHOULD_ANIMATE_IN,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction,
      shouldAnimateIn: shouldAnimateIn
    }
  };
}

function failUnfollowUser(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.FAIL_UNFOLLOW_USER,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function successUnfollowUser(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.SUCCESS_UNFOLLOW_USER,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function unfollowUser(feedUserType, feedUserRelatedId) {
  var logData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (dispatch) {
    dispatch(requestUnfollowUser(feedUserType, feedUserRelatedId));

    var requestData = _extends({
      friendId: {
        type: feedUserType,
        relatedId: feedUserRelatedId
      }
    }, (0, _loggingUtil.generateObjectWithPascalCaseKeys)(logData));

    _services2.default.unfollowUser(requestData).fail(function () {
      return dispatch(failUnfollowUser(feedUserType, feedUserRelatedId));
    }).done(function () {
      dispatch(successUnfollowUser(feedUserType, feedUserRelatedId));
      dispatch((0, _featuredAthleteActionCreators.shouldCheckForFollowingTeamUpdates)(true));
    });
  };
}

// Toggle follow user
function toggleFollowUserIfNeeded(feedUserType, feedUserRelatedId, data) {
  return function (dispatch, getState) {
    var _getFollowStatus = getFollowStatus(getState(), feedUserType, feedUserRelatedId),
        isFollowing = _getFollowStatus.isFollowing,
        isPending = _getFollowStatus.isPending;

    if (!isPending) {
      if (isFollowing) {
        return dispatch(unfollowUser(feedUserType, feedUserRelatedId, data));
      }
      return dispatch(followUser(feedUserType, feedUserRelatedId, data));
    }
  };
}

function setReactionShouldAnimateOut(communityContentType, communityContentRelatedId, reaction, shouldAnimateOut) {
  return {
    type: _actionTypes.SET_REACTION_SHOULD_ANIMATE_OUT,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction,
      shouldAnimateOut: shouldAnimateOut
    }
  };
}

// Add reaction
function requestAddReaction(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.REQUEST_ADD_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function failAddReaction(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.FAIL_ADD_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function successAddReaction(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.SUCCESS_ADD_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function addReaction(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch, getState) {
    var previousState = getState();

    dispatch(requestAddReaction(communityContentType, communityContentRelatedId, reaction));

    var previousReactionCount = getPreviousReactionCount(previousState, communityContentType, communityContentRelatedId, reaction);
    if (previousReactionCount >= 0) {
      dispatch(setReactionShouldAnimateIn(communityContentType, communityContentRelatedId, reaction, true));
    }

    _services2.default.addReaction(communityContentType, communityContentRelatedId, reaction, data).fail(function () {
      return dispatch(failAddReaction(communityContentType, communityContentRelatedId, reaction));
    }).done(function () {
      return dispatch(successAddReaction(communityContentType, communityContentRelatedId, reaction));
    });

    var pixels = getReactionTrackingPixels(previousState, communityContentType, communityContentRelatedId);
    (0, _pixelTracker2.default)(pixels);
  };
}

function shouldAddReaction(state, communityContentType, communityContentRelatedId, reaction) {
  var _getReactionStatus = getReactionStatus(state, communityContentType, communityContentRelatedId, reaction),
      hasAlreadyReacted = _getReactionStatus.hasAlreadyReacted,
      hasPendingReaction = _getReactionStatus.hasPendingReaction;

  return !(hasAlreadyReacted || hasPendingReaction);
}

function addReactionIfNeeded(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch, getState) {
    if (shouldAddReaction(getState(), communityContentType, communityContentRelatedId, reaction)) {
      return dispatch(addReaction(communityContentType, communityContentRelatedId, reaction, data));
    }
  };
}

// Remove reaction
function requestRemoveReaction(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.REQUEST_REMOVE_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function failRemoveReaction(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.FAIL_REMOVE_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function successRemoveReaction(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.SUCCESS_REMOVE_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function removeReaction(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch) {
    dispatch(requestRemoveReaction(communityContentType, communityContentRelatedId, reaction));
    dispatch(setReactionShouldAnimateOut(communityContentType, communityContentRelatedId, reaction, true));

    _services2.default.removeReaction(communityContentType, communityContentRelatedId, reaction, data).then(function () {
      return dispatch(successRemoveReaction(communityContentType, communityContentRelatedId, reaction));
    }).fail(function () {
      return dispatch(failRemoveReaction(communityContentType, communityContentRelatedId, reaction));
    });
  };
}

function shouldRemoveReaction(state, communityContentType, communityContentRelatedId, reaction) {
  var _getReactionStatus2 = getReactionStatus(state, communityContentType, communityContentRelatedId, reaction),
      hasAlreadyReacted = _getReactionStatus2.hasAlreadyReacted,
      hasPendingReaction = _getReactionStatus2.hasPendingReaction;

  return hasAlreadyReacted && !hasPendingReaction;
}

function removeReactionIfNeeded(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch, getState) {
    if (shouldRemoveReaction(getState(), communityContentType, communityContentRelatedId, reaction)) {
      return dispatch(removeReaction(communityContentType, communityContentRelatedId, reaction, data));
    }
  };
}

// Toggle reaction
function toggleReactionIfNeeded(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch, getState) {
    var _getReactionStatus3 = getReactionStatus(getState(), communityContentType, communityContentRelatedId, reaction),
        hasAlreadyReacted = _getReactionStatus3.hasAlreadyReacted,
        hasPendingReaction = _getReactionStatus3.hasPendingReaction;

    if (!hasPendingReaction) {
      if (hasAlreadyReacted) {
        return dispatch(removeReaction(communityContentType, communityContentRelatedId, reaction, data));
      }
      return dispatch(addReaction(communityContentType, communityContentRelatedId, reaction, data));
    }
  };
}

// Add contentReaction (for bootstrapping the store)
function addContentReaction(communityContentType, communityContentRelatedId, contentReaction) {
  return {
    type: _actionTypes.ADD_CONTENT_REACTION,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      contentReaction: contentReaction
    }
  };
}

function addContentReactionIfNeeded(communityContentType, communityContentRelatedId, contentReaction) {
  return function (dispatch, getState) {
    var state = getState();
    var contentReactions = state.reaction.contentReactions;

    var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;
    var hasContentReaction = contentReactions.hasOwnProperty(communityContentIdKey);

    if (!hasContentReaction) {
      var reactions = contentReaction.reactions;


      var existingReactions = [];
      if (Object.keys(reactions).length > 0) {
        existingReactions = Object.keys(reactions).sort(function (reactionA, reactionB) {
          return (reactions[reactionB].count || 0) - (reactions[reactionA].count || 0);
        });
      }

      contentReaction.existingReactions = existingReactions;

      return dispatch(addContentReaction(communityContentType, communityContentRelatedId, contentReaction));
    }
  };
}

// Fetch reaction users for displaying reaction details
function requestReactionUsers(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.REQUEST_REACTION_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function failReceiveReactionUsers(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.FAIL_RECEIVE_REACTION_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function receiveReactionUsers(communityContentType, communityContentRelatedId, reaction, responseData) {
  var firstReactionDate = responseData.firstReactionDate,
      users = responseData.users;


  return {
    type: _actionTypes.RECEIVE_REACTION_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction,
      firstReactionDate: firstReactionDate,
      users: users
    }
  };
}

function finishedReactionUsers(communityContentType, communityContentRelatedId, reaction) {
  return {
    type: _actionTypes.FINISHED_REACTION_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      reaction: reaction
    }
  };
}

function fetchReactionUsers(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch, getState) {
    var state = getState();
    var contentReactionDetails = state.reaction.contentReactionDetails;


    var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

    var _ref2 = contentReactionDetails[communityContentIdKey] || {},
        _ref2$reactionDetails = _ref2.reactionDetails,
        reactionDetails = _ref2$reactionDetails === undefined ? {} : _ref2$reactionDetails;

    var _ref3 = reactionDetails[reaction] || {},
        nextReactionDate = _ref3.nextReactionDate;

    var requestData = Object.assign({}, data, {
      reaction: reaction,
      beforeDateTime: nextReactionDate,
      excludeCurrentUser: true
    });

    dispatch(requestReactionUsers(communityContentType, communityContentRelatedId, reaction));

    _services2.default.getInteractions(communityContentType, communityContentRelatedId, requestData).fail(function () {
      return dispatch(failReceiveReactionUsers(communityContentType, communityContentRelatedId, reaction));
    }).done(function (responseData) {
      var action = dispatch(receiveReactionUsers(communityContentType, communityContentRelatedId, reaction, responseData));
      var _action$payload$users = action.payload.users,
          users = _action$payload$users === undefined ? [] : _action$payload$users;
      // If the next state has the same number of users as the previous state
      // the store needs to be updated to indicate that no more users should be loaded

      if (!users.length) {
        dispatch(finishedReactionUsers(communityContentType, communityContentRelatedId, reaction));
      }

      // Update the follow status for each user to ensure we have the latest state
      users.forEach(function (_ref4) {
        var feedUserId = _ref4.feedUserId,
            isFollowing = _ref4.isFollowing;
        var feedUserType = feedUserId.type,
            feedUserRelatedId = feedUserId.relatedId;

        dispatch(setUserFollow(feedUserType, feedUserRelatedId, isFollowing));
      });
    });
  };
}

function shouldFetchReactionUsers(state, communityContentType, communityContentRelatedId, reaction) {
  var contentReactionDetails = state.reaction.contentReactionDetails;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _ref5 = contentReactionDetails[communityContentIdKey] || {},
      _ref5$reactionDetails = _ref5.reactionDetails,
      reactionDetails = _ref5$reactionDetails === undefined ? {} : _ref5$reactionDetails;

  var _ref6 = reactionDetails[reaction] || {},
      _ref6$isError = _ref6.isError,
      isError = _ref6$isError === undefined ? false : _ref6$isError,
      _ref6$isFetching = _ref6.isFetching,
      isFetching = _ref6$isFetching === undefined ? false : _ref6$isFetching,
      _ref6$isFinished = _ref6.isFinished,
      isFinished = _ref6$isFinished === undefined ? false : _ref6$isFinished;

  return !(isFetching || isFinished || isError);
}

function fetchReactionUsersIfNeeded(communityContentType, communityContentRelatedId, reaction, data) {
  return function (dispatch, getState) {
    if (shouldFetchReactionUsers(getState(), communityContentType, communityContentRelatedId, reaction)) {
      return dispatch(fetchReactionUsers(communityContentType, communityContentRelatedId, reaction, data));
    }
  };
}

// Fetch tag users for displaying tag details
function requestTagUsers(communityContentType, communityContentRelatedId) {
  return {
    type: _actionTypes.REQUEST_TAG_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId
    }
  };
}

function failReceiveTagUsers(communityContentType, communityContentRelatedId) {
  return {
    type: _actionTypes.FAIL_RECEIVE_TAG_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId
    }
  };
}

function receiveTagUsers(communityContentType, communityContentRelatedId, responseData) {
  var _responseData$lastUse = responseData.lastUserTagId,
      lastUserTagId = _responseData$lastUse === undefined ? null : _responseData$lastUse,
      _responseData$users = responseData.users,
      users = _responseData$users === undefined ? [] : _responseData$users;


  return {
    type: _actionTypes.RECEIVE_TAG_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      lastUserTagId: lastUserTagId,
      users: users
    }
  };
}

function finishedTagUsers(communityContentType, communityContentRelatedId) {
  return {
    type: _actionTypes.FINISHED_TAG_USERS,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId
    }
  };
}

function fetchTagUsers(communityContentType, communityContentRelatedId, data) {
  return function (dispatch, getState) {
    var state = getState();
    var contentTagDetails = state.tags.contentTagDetails;


    var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

    var _ref7 = contentTagDetails[communityContentIdKey] || {},
        _ref7$tagDetails = _ref7.tagDetails,
        tagDetails = _ref7$tagDetails === undefined ? {} : _ref7$tagDetails;

    var _ref8 = tagDetails || {},
        lastUserTagId = _ref8.lastUserTagId;

    var requestData = Object.assign({}, data);
    if (lastUserTagId) {
      requestData.lastUserTagId = lastUserTagId;
    }

    dispatch(requestTagUsers(communityContentType, communityContentRelatedId));

    _services2.default.getTaggedUsers(communityContentType, communityContentRelatedId, requestData).fail(function () {
      return dispatch(failReceiveTagUsers(communityContentType, communityContentRelatedId));
    }).done(function (responseData) {
      var _responseData$users2 = responseData.users,
          users = _responseData$users2 === undefined ? [] : _responseData$users2;

      if (!users.length) {
        // If the next state has the same number of users as the previous state
        // the store needs to be updated to indicate that no more users should be loaded
        dispatch(finishedTagUsers(communityContentType, communityContentRelatedId));
      }

      dispatch(receiveTagUsers(communityContentType, communityContentRelatedId, responseData));

      // Update the follow status for each user to ensure we have the latest state
      users.forEach(function (_ref9) {
        var feedUserId = _ref9.feedUserId,
            isFollowing = _ref9.isFollowing;
        var feedUserType = feedUserId.type,
            feedUserRelatedId = feedUserId.relatedId;

        dispatch(setUserFollow(feedUserType, feedUserRelatedId, isFollowing));
      });
    });
  };
}

function shouldFetchTagUsers(state, communityContentType, communityContentRelatedId) {
  var contentTagDetails = state.tags.contentTagDetails;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _ref10 = contentTagDetails[communityContentIdKey] || {},
      _ref10$tagDetails = _ref10.tagDetails,
      tagDetails = _ref10$tagDetails === undefined ? {} : _ref10$tagDetails;

  var _ref11 = tagDetails || {},
      _ref11$isError = _ref11.isError,
      isError = _ref11$isError === undefined ? false : _ref11$isError,
      _ref11$isFetching = _ref11.isFetching,
      isFetching = _ref11$isFetching === undefined ? false : _ref11$isFetching,
      _ref11$isFinished = _ref11.isFinished,
      isFinished = _ref11$isFinished === undefined ? false : _ref11$isFinished;

  return !(isFetching || isFinished || isError);
}

function fetchTagUsersIfNeeded(communityContentType, communityContentRelatedId, data) {
  return function (dispatch, getState) {
    if (shouldFetchTagUsers(getState(), communityContentType, communityContentRelatedId)) {
      return dispatch(fetchTagUsers(communityContentType, communityContentRelatedId, data));
    }
  };
}

function requestCommunityContentMetadata(communityContentType, communityContentRelatedId) {
  return {
    type: _actionTypes.REQUEST_COMM_CONTENT_METADATA,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId
    }
  };
}

function failReceiveCommunityContentMetadata(communityContentType, communityContentRelatedId) {
  return {
    type: _actionTypes.FAIL_RECEIVE_COMM_CONTENT_METADATA,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId
    }
  };
}

function receiveCommunityContentMetadata(communityContentType, communityContentRelatedId, responseData) {
  return {
    type: _actionTypes.RECEIVE_COMM_CONTENT_METADATA,
    payload: {
      communityContentType: communityContentType,
      communityContentRelatedId: communityContentRelatedId,
      responseData: responseData
    }
  };
}

function fetchCommunityContentMetadata(communityContentType, communityContentRelatedId, data) {
  return function (dispatch) {
    var requestData = Object.assign({}, data);
    dispatch(requestCommunityContentMetadata(communityContentType, communityContentRelatedId));

    _services2.default.getCommunityContentMetadata(communityContentType, communityContentRelatedId, requestData).fail(function () {
      return dispatch(failReceiveCommunityContentMetadata(communityContentType, communityContentRelatedId));
    }).done(function (responseData) {
      dispatch(receiveCommunityContentMetadata(communityContentType, communityContentRelatedId, responseData));
    });
  };
}

function shouldFetchCommunityContentMetadata(state, communityContentType, communityContentRelatedId) {
  var contentReactions = state.reaction.contentReactions;


  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  // As of now, requesting reaction data and requesting community content metadata is the same thing
  var reactionData = contentReactions[communityContentIdKey];
  return !reactionData;
}

function fetchCommunityContentMetadataIfNeeded(communityContentType, communityContentRelatedId, data) {
  return function (dispatch, getState) {
    if (shouldFetchCommunityContentMetadata(getState(), communityContentType, communityContentRelatedId)) {
      return dispatch(fetchCommunityContentMetadata(communityContentType, communityContentRelatedId, data));
    }
  };
}

// Fetch current user details
function requestCurrentUserDetails() {
  return {
    type: _actionTypes.REQUEST_CURRENT_USER_DETAILS,
    payload: {}
  };
}

function failReceiveCurrentUserDetails() {
  return {
    type: _actionTypes.FAIL_RECEIVE_CURRENT_USER_DETAILS,
    payload: {}
  };
}

function receiveCurrentUserDetails(responseData) {
  return {
    type: _actionTypes.RECEIVE_CURRENT_USER_DETAILS,
    payload: {
      currentUserDetails: responseData
    }
  };
}

function fetchCurrentUserDetails() {
  return function (dispatch) {
    dispatch(requestCurrentUserDetails());
    _services2.default.getCurrentUserDetails().fail(function () {
      return dispatch(failReceiveCurrentUserDetails());
    }).done(function (responseData) {
      return dispatch(receiveCurrentUserDetails(responseData));
    });
  };
}

function shouldFetchCurrentUserDetails(state) {
  var userDetails = state.userDetails;
  var currentUser = userDetails.currentUser;
  var _currentUser$isError = currentUser.isError,
      isError = _currentUser$isError === undefined ? false : _currentUser$isError,
      _currentUser$isFetchi = currentUser.isFetching,
      isFetching = _currentUser$isFetchi === undefined ? false : _currentUser$isFetchi,
      currentUserDetails = currentUser.details;

  // Only fetch current user details if the store doesn't already contain it

  var hasCurrentUserDetails = !!currentUserDetails;

  return !(isError || isFetching) && !hasCurrentUserDetails;
}

function fetchCurrentUserDetailsIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchCurrentUserDetails(getState())) {
      return dispatch(fetchCurrentUserDetails());
    }
  };
}

// Feed item
function addFeedItems(feedItems) {
  return {
    type: _actionTypes.ADD_FEED_ITEMS,
    payload: {
      feedItems: feedItems
    }
  };
}

function requestFeedItem(feedContentId) {
  return {
    type: _actionTypes.REQUEST_FEED_ITEM,
    payload: {
      feedContentId: feedContentId
    }
  };
}

function failFeedItem(feedContentId) {
  return {
    type: _actionTypes.FAIL_FEED_ITEM,
    payload: {
      feedContentId: feedContentId
    }
  };
}

function receiveFeedItem(feedContentId, response) {
  return {
    type: _actionTypes.RECEIVE_FEED_ITEM,
    payload: {
      feedContentId: feedContentId,
      response: response
    }
  };
}

function fetchFeedItem(feedContentId) {
  return function (dispatch) {
    dispatch(requestFeedItem(feedContentId));
    _services2.default.getFeedItem(feedContentId, {
      returnHtml: false
    }).fail(function () {
      return dispatch(failFeedItem(feedContentId));
    }).done(function (response) {
      return dispatch(receiveFeedItem(feedContentId, response));
    });
  };
}

function shouldFetchFeedItem(state, feedContentId) {
  var feedItems = state.feedItems;

  var hasLoadedFeedItem = !!(feedItems && feedItems[feedContentId]);

  return !hasLoadedFeedItem;
}

function fetchFeedItemIfNeeded(feedContentId) {
  return function (dispatch, getState) {
    if (shouldFetchFeedItem(getState(), feedContentId)) {
      return dispatch(fetchFeedItem(feedContentId));
    }
  };
}

function requestDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId) {
  return {
    type: _actionTypes.REQUEST_DISMISS_FEED_ITEM,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId,
      feedContentId: feedContentId
    }
  };
}

function failDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId) {
  return {
    type: _actionTypes.FAIL_DISMISS_FEED_ITEM,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId,
      feedContentId: feedContentId
    }
  };
}

function successDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId) {
  return {
    type: _actionTypes.SUCCESS_DISMISS_FEED_ITEM,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId,
      feedContentId: feedContentId
    }
  };
}

function dismissFeedItem(feedUserType, feedUserRelatedId, feedContentId, isHomeTimeline) {
  return function (dispatch) {
    dispatch(requestDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId, isHomeTimeline));

    if (isHomeTimeline) {
      _services2.default.dismissFeedItem(feedContentId).fail(function () {
        return dispatch(failDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId));
      }).done(function () {
        return dispatch(successDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId));
      });
    } else {
      _services2.default.dismissProfileFeedItem(feedContentId, feedUserType, feedUserRelatedId).fail(function () {
        dispatch(failDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId));
      }).done(function () {
        dispatch(successDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId));
        dispatch({
          type: _actionTypes.HIDE_CONFIRM_DISMISS_FEED_ITEM,
          payload: {
            feedUserType: feedUserType,
            feedUserRelatedId: feedUserRelatedId
          }
        });
      });
    }
  };
}

function hideConfirmDismissFeedItem(feedUserType, feedUserRelatedId) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.HIDE_CONFIRM_DISMISS_FEED_ITEM,
      payload: {
        feedUserType: feedUserType,
        feedUserRelatedId: feedUserRelatedId
      }
    });
  };
}

function showConfirmDismissFeedItem(feedUserType, feedUserRelatedId, feedContentId) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.SHOW_CONFIRM_DISMISS_FEED_ITEM,
      payload: {
        feedUserType: feedUserType,
        feedUserRelatedId: feedUserRelatedId,
        feedContentId: feedContentId
      }
    });
  };
}

// User Timeline
function requestUserTimeline(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.REQUEST_USER_TIMELINE,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function failUserTimeline(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.FAIL_USER_TIMELINE,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function receiveUserTimeline(feedUserType, feedUserRelatedId, response) {
  return {
    type: _actionTypes.RECEIVE_USER_TIMELINE,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId,
      response: { feedItems: response }
    }
  };
}

function fetchUserTimeline(feedUserType, feedUserRelatedId, isHomeTimeline) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return function (dispatch) {
    dispatch(requestUserTimeline(feedUserType, feedUserRelatedId));

    var serviceMethod = isHomeTimeline ? _services2.default.getHomeTimeline(args) : _services2.default.getUserTimeline(feedUserType, feedUserRelatedId, args);

    serviceMethod.fail(function () {
      return dispatch(failUserTimeline(feedUserType, feedUserRelatedId));
    }).done(function (response) {
      dispatch(receiveUserTimeline(feedUserType, feedUserRelatedId, response));
    });
  };
}

function shouldFetchUserTimeline(state, feedUserType, feedUserRelatedId) {
  var userTimeline = state.userTimeline;

  var feedUserKey = feedUserType + '-' + feedUserRelatedId;

  if (!(userTimeline && userTimeline[feedUserKey])) {
    return true;
  }

  var _userTimeline$feedUse = userTimeline[feedUserKey],
      feedItems = _userTimeline$feedUse.feedItems,
      isError = _userTimeline$feedUse.isError,
      isFetching = _userTimeline$feedUse.isFetching;


  return !isError && !isFetching && !feedItems;
}

function fetchMoreInTimeline(feedUserType, feedUserRelatedId, isHomeTimeline) {
  var filterType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _presetFilterType2.default.None;
  var forcePublicView = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  return function (dispatch, getState) {
    var _getState = getState(),
        feedItems = _getState.feedItems,
        userTimeline = _getState.userTimeline;

    var feedUserKey = feedUserType + '-' + feedUserRelatedId;
    var existingTimeline = userTimeline && userTimeline[feedUserKey] && userTimeline[feedUserKey].feedItems;
    if (!existingTimeline || !existingTimeline.length || userTimeline[feedUserKey].isFetching) return;

    var lastFeedItem = feedItems[existingTimeline[existingTimeline.length - 1]];
    var beforeDateTime = lastFeedItem && lastFeedItem.content && lastFeedItem.content.dateCreated;

    if (!beforeDateTime) {
      return;
    }

    if (!userTimeline[feedUserKey].isEndOfTimeline) {
      (0, _comscore2.default)();
    }

    dispatch(fetchUserTimeline(feedUserType, feedUserRelatedId, isHomeTimeline, {
      beforeDateTime: beforeDateTime,
      filterType: filterType,
      forcePublicView: forcePublicView
    }));
  };
}

function fetchUserTimelineIfNeeded(feedUserType, feedUserRelatedId, isHomeTimeline) {
  var filterType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _presetFilterType2.default.None;
  var forcePublicView = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  return function (dispatch, getState) {
    if (shouldFetchUserTimeline(getState(), feedUserType, feedUserRelatedId)) {
      return dispatch(fetchUserTimeline(feedUserType, feedUserRelatedId, isHomeTimeline, { filterType: filterType, forcePublicView: forcePublicView }));
    }
  };
}

// Mini profile
function requestMiniProfile(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.REQUEST_MINI_PROFILE,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function failMiniProfile(feedUserType, feedUserRelatedId) {
  return {
    type: _actionTypes.FAIL_MINI_PROFILE,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId
    }
  };
}

function receiveMiniProfile(feedUserType, feedUserRelatedId, response) {
  return {
    type: _actionTypes.RECEIVE_MINI_PROFILE,
    payload: {
      feedUserType: feedUserType,
      feedUserRelatedId: feedUserRelatedId,
      response: response
    }
  };
}

function fetchMiniProfile(feedUserType, feedUserRelatedId) {
  return function (dispatch) {
    dispatch(requestMiniProfile(feedUserType, feedUserRelatedId));
    _services2.default.getMiniProfile(feedUserType, feedUserRelatedId, {
      returnHtml: false
    }).fail(function () {
      return dispatch(failMiniProfile(feedUserType, feedUserRelatedId));
    }).done(function (response) {
      return dispatch(receiveMiniProfile(feedUserType, feedUserRelatedId, response));
    });
  };
}

function shouldFetchMiniProfile(state, feedUserType, feedUserRelatedId) {
  var miniProfile = state.miniProfile;

  var _ref12 = miniProfile || {},
      feedUsers = _ref12.feedUsers;

  var feedUserKey = feedUserType + '-' + feedUserRelatedId;
  var hasLoadedMiniProfile = !!(feedUsers && feedUsers[feedUserKey]);

  return !hasLoadedMiniProfile;
}

function fetchMiniProfileIfNeeded(feedUserType, feedUserRelatedId) {
  return function (dispatch, getState) {
    if (shouldFetchMiniProfile(getState(), feedUserType, feedUserRelatedId)) {
      return dispatch(fetchMiniProfile(feedUserType, feedUserRelatedId));
    }
  };
}

function showMiniProfile(feedUserType, feedUserRelatedId) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.SHOW_MINI_PROFILE,
      payload: {
        feedUserType: feedUserType,
        feedUserRelatedId: feedUserRelatedId
      }
    });
  };
}

function hideMiniProfile() {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.HIDE_MINI_PROFILE
    });
  };
}

// Share content
function shareContent(feedContentId, isMiniProfile) {
  var notification = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var title = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var showHighlightCta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  return {
    type: _actionTypes.SHARE_CONTENT,
    feedContentId: feedContentId,
    notification: notification,
    showHighlightCta: showHighlightCta,
    title: title,
    isMiniProfile: isMiniProfile
  };
}

function communityContentShared(communityContentId, logData) {
  return function (dispatch, getState) {
    var state = getState();
    _services2.default.logCommunityContentShare(getCommunityIdString(communityContentId), logData);
    var pixels = getShareTrackingPixels(state, communityContentId);
    (0, _pixelTracker2.default)(pixels);
  };
}

// Theatre dialog
function closeTheatre() {
  return { type: _actionTypes.THEATRE_CLOSE };
}

function requestRecommendedVideos() {
  return { type: _actionTypes.THEATRE_REQUEST_RECOMMENDED_VIDEOS };
}

function failedToGetRecommendedVideos() {
  return { type: _actionTypes.THEATRE_FAIL_RECOMMENDED_VIDEOS };
}

function receiveRecommendedVideos(recommendations) {
  return { type: _actionTypes.THEATRE_RECEIVE_RECOMMENDED_VIDEOS, recommendations: recommendations };
}

function getRecommendedVideos(params) {
  return function (dispatch) {
    dispatch(requestRecommendedVideos());

    _services2.default.getRecommendedVideos(params).fail(function () {
      return dispatch(failedToGetRecommendedVideos());
    }).done(function (response) {
      var recommendations = response.recommendations;
      dispatch(receiveRecommendedVideos(recommendations));
      recommendations.forEach(function (recommendation) {
        var _recommendation$commu = recommendation.communityContentId,
            relatedId = _recommendation$commu.relatedId,
            type = _recommendation$commu.type;

        fetchCommunityContentMetadata(type, relatedId)(dispatch);
      });
    });
  };
}

function selectTheatreRecommendation(communityContentId) {
  return { type: _actionTypes.THEATRE_SELECT_RECOMMENDATION, communityContentId: communityContentId };
}

function shareTheatreRecommendation(communityContentId) {
  return { type: _actionTypes.THEATRE_SHARE_RECOMMENDATION, communityContentId: communityContentId };
}

function pauseAllVideos() {
  var currentPlayerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return function (dispatch, getState) {
    var players = getState().players;
    for (var playerId in players) {
      if (playerId && (!currentPlayerId || currentPlayerId !== playerId)) {
        dispatch(_hudlVideoInterface.viActions.pause(playerId));
      }
    }
  };
}

function openTheatre(feedContentId, isMiniProfile) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(pauseAllVideos());

    var feedItem = state.feedItems[feedContentId];
    var communityContentId = feedItem.content.communityContentId;
    var communityContentIdSerialized = getCommunityIdString(communityContentId);
    dispatch({
      type: _actionTypes.COMMUNITY_CONTENT_ENTER_VIEW,
      communityContentIdSerialized: communityContentIdSerialized,
      location: 'THEATRE_PLAYER'
    });

    dispatch({ type: _actionTypes.THEATRE_OPEN, feedContentId: feedContentId, isMiniProfile: isMiniProfile });
  };
}

function communityContentEnterView(communityContentId, location, logData) {
  return function (dispatch, getState) {
    var state = getState();
    var communityContentIdSerialized = getCommunityIdString(communityContentId);
    dispatch({
      type: _actionTypes.COMMUNITY_CONTENT_ENTER_VIEW,
      communityContentIdSerialized: communityContentIdSerialized,
      location: location
    });

    var inView = state.communityContent.inView[communityContentIdSerialized] || [];
    if (!inView.includes(location)) {
      _services2.default.logFeedContentView(logData);
      var pixels = getImpressionTrackingPixels(state, communityContentId);
      (0, _pixelTracker2.default)(pixels);
    }
  };
}

function communityContentLeaveView(communityContentId, location /* , logData */) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.COMMUNITY_CONTENT_LEAVE_VIEW,
      communityContentIdSerialized: getCommunityIdString(communityContentId),
      location: location
    });
  };
}

function communityContentVideoPlay(communityContentId, playerId /* , logData */) {
  // Log data not currently being used, perserving it for consistency across these methods.
  return function (dispatch) {
    dispatch(pauseAllVideos(playerId));
    dispatch({
      type: _actionTypes.COMMUNITY_CONTENT_VIDEO_PLAY,
      communityContentIdSerialized: getCommunityIdString(communityContentId),
      playerId: playerId
    });
  };
}

function playedQuartile(quartiles, quartile) {
  return quartiles.map(function (value, index) {
    return index === quartile ? true : value;
  });
}

function updatePlayed(dispatch, previousState, communityContentId, positionMs, durationMs, logData) {
  var previousPlayingState = previousState.communityContent.playing[getCommunityIdString(communityContentId)] || {};

  // Can race after video complets that additional updates to player position change.
  if (positionMs >= _logValues.MINIMUM_VIDEO_PLAY_TIME_MS && !previousPlayingState.isVideoComplete) {
    var previousQuartiles = previousPlayingState.quartiles || [false, false, false, false];

    var quartiles = previousQuartiles;
    var quartileMs = durationMs / 4;
    var communityContentIdSerialized = getCommunityIdString(communityContentId);
    for (var quartile = 0; quartile <= 4 && positionMs > quartile * quartileMs; quartile++) {
      if (!quartiles[quartile]) {
        quartiles = playedQuartile(quartiles, quartile);
        if (quartile === 0) {
          // Needs to be moved to state.
          _sessionViews2.default.increment();
        }
      }
    }

    if (quartiles !== previousPlayingState.quartiles) {
      dispatch({
        type: _actionTypes.COMMUNITY_CONTENT_VIDEO_QUARTILES_UPDATED,
        communityContentIdSerialized: communityContentIdSerialized,
        quartiles: quartiles
      });

      // Put the network ops on the back of the dispatch.
      var pixels = [];
      for (var _quartile = 0; _quartile <= 4; _quartile++) {
        if (!previousQuartiles[_quartile] && quartiles[_quartile]) {
          pixels = pixels.concat(getQuartileTrackingPixels(previousState, _quartile, communityContentId));
          _services2.default.logCommunityVideoQuartile(_quartile, communityContentIdSerialized, logData);
        }
      }

      (0, _pixelTracker2.default)(pixels);
    }
  }
}

function communityContentVideoPositionUpdated(communityContentId, positionMs, durationMs, logData) {
  return function (dispatch, getState) {
    var previousState = getState();
    dispatch({
      type: _actionTypes.COMMUNITY_CONTENT_VIDEO_POSITION_UPDATE,
      communityContentIdSerialized: getCommunityIdString(communityContentId),
      positionMs: positionMs
    });

    updatePlayed(dispatch, previousState, communityContentId, positionMs, durationMs, logData);
  };
}

function communityContentVideoStopped(communityContentId, playerId, isVideoComplete, shouldContinueVideo, logData) {
  return function (dispatch, getState) {
    var previousState = getState();
    var communityContentIdSerialized = getCommunityIdString(communityContentId);

    dispatch({
      type: _actionTypes.COMMUNITY_CONTENT_VIDEO_STOP,
      communityContentIdSerialized: communityContentIdSerialized,
      playerId: playerId,
      isVideoComplete: isVideoComplete,
      shouldContinueVideo: shouldContinueVideo
    });

    var previousPlayingState = previousState.communityContent.playing[communityContentIdSerialized] || {};
    if (previousPlayingState.isVideoComplete) {
      // Don't log or update if we have already completed.
      return;
    }

    var players = (previousPlayingState.players || []).filter(function (x) {
      return x !== playerId;
    });
    for (var i = 0; i < players.length; i++) {
      if (!isVideoComplete && shouldContinueVideo && i === players.length - 1) {
        // Only start playing the last active video player.
        // Seeking JW player causes play events to happen, which is bad.
        dispatch(_hudlVideoInterface.viActions.setCurrentTimeMs(players[i], previousPlayingState.positionMs));
        dispatch(_hudlVideoInterface.viActions.play(players[i]));
      } else {
        dispatch(_hudlVideoInterface.viActions.setQueueEnded(players[i], true));
      }
    }

    if (isVideoComplete) {
      var pixels = getVideoCompleteTrackingPixels(previousState, communityContentId);
      (0, _pixelTracker2.default)(pixels);
      _services2.default.logCommunityVideoComplete(communityContentIdSerialized, logData);
    }

    _services2.default.logCommunityVideoStop(communityContentIdSerialized, logData);
  };
}

function fetchHeaderBid() {
  return function (dispatch) {
    (0, _adUtility.fetchAPSVideoBid)().then(function (bid) {
      dispatch({ type: _actionTypes.FETCH_HEADER_BID, bid: bid });
    }).catch(function () {
      dispatch({ type: _actionTypes.FETCH_HEADER_BID, bid: '' });
    });
  };
}